import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IOfferListingStore {
    isListingNavigationSticky: boolean;
}

export const offerListingSliceInitialState: IOfferListingStore = {
    isListingNavigationSticky: false
};

export const offerListingSlice = createSlice({
    name: "offerListing",
    initialState: offerListingSliceInitialState,
    reducers: {
        setOfferListingNavigationSticky: (state, action: PayloadAction<boolean>) => {
            state.isListingNavigationSticky = action.payload;
        }
    }
});

export const {setOfferListingNavigationSticky} = offerListingSlice.actions;
